import { render } from "./UsuariosView.vue?vue&type=template&id=45011bc8"
import script from "./UsuariosView.vue?vue&type=script&lang=js"
export * from "./UsuariosView.vue?vue&type=script&lang=js"

import "./UsuariosView.vue?vue&type=style&index=0&id=45011bc8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__